import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubscriberLicenseesRequest } from './actions';

const Licensees = () => {
     const dispatch = useDispatch();
     const licensees = useSelector((state) => state.subscriber.licensees);

     const fetchData = () => {
          if (!licensees?.length) {
               dispatch(fetchSubscriberLicenseesRequest());
          }
     };
     useEffect(fetchData, []); // eslint-disable-line react-hooks/exhaustive-deps

     return <></>;
};

export default Licensees;
